import {
  Autocomplete,
  Button,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import { useFormik } from "formik";
import { Dialog } from "primereact/dialog";
import { useEffect, useRef, useState } from "react";
//import NoPosition from "../../assets/vectors/NoPositionVector.png";
import * as Yup from "yup";
import {
  DeletePositionByUserIdAndAddNewPosition,
  GetAllEmptyPositions,
  GetMyPosition,
  GetPositionRoleByPositionIdAndRole,
} from "../../services/PositionService";
import {
  CreateInvitation,
  UpdateInvitation,
} from "../../services/InvitationService";
import toast from "react-hot-toast";
import { AgGridReact } from "@ag-grid-community/react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import axios from "axios";
import { ICellRendererParams, ModuleRegistry } from "@ag-grid-community/core";
import { ServerSideRowModelModule } from "@ag-grid-enterprise/server-side-row-model";
import React from "react";
import { GURL } from "../../services/global";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchUserPosition,
  getMyPosition,
} from "../../features/position/positionSlice";
import ConvertToShamsi from "../../extentions/convertors/ConvertToShamsi";

ModuleRegistry.registerModules([ServerSideRowModelModule]);

const MyInvitations = () => {
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);

  const updateScreenHeight = () => {
    setScreenHeight(window.innerHeight);
  };

  var enterprise = require("@ag-grid-enterprise/core");
  enterprise.LicenseManager.setLicenseKey(
    "DownloadDevTools_COM_NDEwMjM0NTgwMDAwMA==59158b5225400879a12a96634544f5b6"
  );

  // /
  const handleOptionChange = (event: any, option: any) => {
    //alert(option.id);
    if (option) {
      SetDataInfoManaully("positionId", option.id);
    }
  };

  async function GetAllEmptyPositionsAsync() {
    return await GetAllEmptyPositions();
  }
  /* Start Of Checking User Has Position */
  const [myPosition, SetMyPosition] = useState<any>("");
  async function GetMyPositionAsync() {
    await GetMyPosition().then((p) => {
      if (p.status === 200) {
        SetMyPosition(p.data);
      } else {
        SetMyPosition(null);
      }
    });
  }
  /* End Of Checking  */
  const dispatch = useDispatch<any>();
  const myPositions = useSelector(getMyPosition);

  async function DeletePositionByUserIdAndAddNewPositionAsync(positionId: any) {
    //    console.log(getInvitation.positionId);
    //console.log(getUser.id);

    await DeletePositionByUserIdAndAddNewPosition({
      positionId: positionId,
    }).then(() => {
      navigate("/");
    });
  }

  useEffect(() => {
    GetMyPositionAsync();
    dispatch(fetchUserPosition());
    setData({
      ...getData,
      ["InvitationType"]: 0,
    });
    window.addEventListener("resize", updateScreenHeight);

    return () => {
      window.removeEventListener("resize", updateScreenHeight);
    };
  }, []);

  useEffect(() => {
    if (myPositions) {
      if (myPositions.positions.name !== undefined) {
        GetPositionRoleByPositionIdAndRoleAsync();
      }
    }
  }, [myPositions]);

  const [SendInvitation, setSendInvitation] = React.useState(false);
  async function GetPositionRoleByPositionIdAndRoleAsync() {
    await GetPositionRoleByPositionIdAndRole(
      myPositions.positions.id,
      "SendInvitation"
    ).then((p) => setSendInvitation(p.data.data));
  }

  const [getData, setData] = useState<any>();

  const SetDataInfo = (event: any) => {
    setData({
      ...getData,
      [event.target.name]: event.target.value,
    });
  };
  const SetDataInfoManaully = (key: any, value: any) => {
    setData({
      ...getData,
      [key]: value,
    });
  };

  const PositionCellRenderer: React.FC<ICellRendererParams> = ({
    value,
    valueFormatted,
  }) => {
    //let cellValue = ""; // valueFormatted ? valueFormatted : value;
    const [cellValue, setCellValue] = useState("");

    axios
      .get(`${GURL}/Company/v1/position/GetPositionById?id=${value}`)
      .then((response) => {
        //00console.log("RER");
        //console.log(response.data);

        setCellValue(response.data.name); // ;
        //  console.log(cellValue);

        // Return data to Ag Grid
      })
      .catch((error) => {
        console.error(error);
        // Return error to Ag Grid
      });

    return <span>{cellValue}</span>;
  };

  const navigate = useNavigate();

  async function UpdateInvitationAsync(state: number, invitationId: any) {
    await UpdateInvitation({
      invitationId: invitationId,
      invitationState: state,
    })
      .then(() => navigate("/"))
      .then(() => toast.success("دعوتنامه مورد نظر شما منقضی شد"));
  }

  const CustomCellRenderer: React.FC<ICellRendererParams> = (params) => {
    console.log("pa", params);

    const [cellValue, setCellValue] = useState("منقضی شده");

    axios
      .get(
        `${GURL}/Company/v1/Invitation/GetLastState?InvitationId=${params?.data?.id}`
      )
      .then((response) => {
        //00console.log("RER");
        //console.log(response.data);

        setCellValue(response.data.message); // ;
        //console.log(cellValue);

        // Return data to Ag Grid
      })
      .catch((error) => {
        console.error(error);
        // Return error to Ag Grid
      });
    return (
      <>
        {cellValue === "منقضی شده" ||
        cellValue === "پذیرفته شده" ||
        cellValue === "رد شده" ? (
          <> </>
        ) : (
          <>
            {" "}
            <span className="">
              <Button
                style={{ height: "2rem" }}
                variant="outlined"
                color="success"
                onClick={() => {
                  UpdateInvitationAsync(2, params?.data?.id);
                  DeletePositionByUserIdAndAddNewPositionAsync(
                    params?.data?.positionId
                  );
                }}
              >
                پذیرفتن
              </Button>
            </span>
            <span className="">
              <Button
                style={{ height: "2rem" }}
                variant="outlined"
                color="error"
                onClick={() => {
                  UpdateInvitationAsync(3, params?.data?.id);
                }}
              >
                رد کردن
              </Button>
            </span>
          </>
        )}
      </>
    );
  };

  const CompanyCellRenderer: React.FC<ICellRendererParams> = (params: any) => {
    //console.log("s", params.data.company.name);

    //let cellValue = ""; // valueFormatted ? valueFormatted : value;

    // axios
    // 	.get(`${GURL}/Company/v1/Invitation/GetLastState?InvitationId=${value}`)
    // 	.then((response) => {
    // 		//00console.log("RER");
    // 		//console.log("ss", response.data);

    // 		setCellValue(response.data.message); // ;
    // 		//console.log(cellValue);

    // 		// Return data to Ag Grid
    // 	})
    // 	.catch((error) => {
    // 		console.error(error);
    // 		// Return error to Ag Grid
    // 	});

    return <span>{params?.data?.company?.name}</span>;
  };

  const StatusCellRenderer: React.FC<ICellRendererParams> = ({
    value,
    valueFormatted,
  }) => {
    //let cellValue = ""; // valueFormatted ? valueFormatted : value;
    const [cellValue, setCellValue] = useState("");

    axios
      .get(`${GURL}/Company/v1/Invitation/GetLastState?InvitationId=${value}`)
      .then((response) => {
        //00console.log("RER");
        //console.log("ss", response.data);

        setCellValue(response.data.message); // ;
        //console.log(cellValue);

        // Return data to Ag Grid
      })
      .catch((error) => {
        console.error(error);
        // Return error to Ag Grid
      });

    return <span>{cellValue}</span>;
  };
  const CellRendererForDateTime: React.FC<ICellRendererParams> = ({
    value,
    valueFormatted,
  }) => {
    //let cellValue = ""; // valueFormatted ? valueFormatted : value;
    const [cellValue, setCellValue] = useState(false);

    return <>{ConvertToShamsi(value)}</>;
  };
  const assigneeModalColumns = [
    {
      field: "firstName",
      headerName: "نام",
      hide: false,
      sortable: false,
      filter: false,
      width: 120,
    },
    {
      field: "lastName",
      headerName: "نام خانوادگی",
      hide: false,
      sortable: false,
      filter: false,
      width: 120,
    },
    {
      field: "positionId",
      headerName: "سمت",
      hide: false,
      sortable: false,
      filter: false,
      width: 120,
      cellRenderer: PositionCellRenderer,
    },
    // {
    //   field: "phoneNumber",
    //   headerName: "شماره همراه",
    //   hide: false,
    //   sortable: false,
    //   filter: false,
    //   width: 120,
    // },
    {
      field: "id",
      headerName: "وضعیت",
      hide: false,
      sortable: false,
      filter: false,
      width: 120,
      cellRenderer: StatusCellRenderer,
    },
    {
      field: "id",
      headerName: "فروشگاه",
      hide: false,
      sortable: false,
      filter: false,
      width: 120,
      cellRenderer: CompanyCellRenderer,
    },
    {
      field: "id",
      headerName: "عملیات",
      hide: false,
      sortable: false,
      filter: false,
      cellRenderer: CustomCellRenderer,
    },
    {
      field: "createdDate",
      headerName: "تاریخ دریافت",
      hide: false,
      sortable: false,
      filter: false,
      cellRenderer: CellRendererForDateTime,
    },

    {
      field: "id",
      hide: true,
      filter: true,
    },
  ];

  const onGridReady = (params: any) => {
    gridApi.current = params.api;
  };
  const gridApi = useRef(null);

  const onFirstDataRendered = () => {
    if (gridApi.current) {
      // (gridApi.current as any).sizeColumnsToFit();
    }
  };

  class MyAssigneModalServerSideDatasource {
    getRows(params: any) {
      // Make API call to fetch data from server
      axios.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${localStorage.getItem("token")}`;
      axios
        .get(`${GURL}/company/v1/Invitation/MyInvitations`)
        .then((response) => {
          if (response?.data?.data) {
            params.successCallback(response.data.data, -1);
          } else {
            params.successCallback([{}], 0);
          }

          // Return data to Ag Grid
        })
        .catch((error) => {
          console.error(error);
          // Return error to Ag Grid
          params.failCallback();
        });
    }
  }

  const assigneeGridOptions = {
    onCellDoubleClicked: async function (event: any) {
      const { data } = event;
    },
    enableRtl: true,

    // ... other grid options ...
    localeText: {
      // ... custom translations ...
      notContains: "شامل نشود",
      contains: "شامل شود",
      equals: "برابر باشد با",
      notEqual: "برابر نباشد با",
      startsWith: "شروع شود با",
      endsWith: "پایان یابد با",
      notBlank: "خالی نباشد",
      blank: "خالی باشد",
      loadingOoo: "در حال بارگزاری لطفا منتظر بمانید",
      andCondition: "و",
      orCondition: "یا",
      loadingError: "متاسفانه خطایی در سرور رخ داده است !",
      pageNotFound: "صفحه مورد نظر یافت نشد",
      noRowsToShow: " رکوردی موجود نیست ",
      filterOoo: "فیلتر . . .",
    },
  };
  return (
    <>
      <div className="col-12 " style={{ display: "" }}>
        <div
          dir="rtl"
          className="mt-2 ag-theme-alpine"
          style={{ width: "100%", height: screenHeight - 200 }}
        >
          <AgGridReact
            columnDefs={assigneeModalColumns}
            rowModelType={"serverSide"}
            gridOptions={assigneeGridOptions}
            onFirstDataRendered={onFirstDataRendered}
            onGridReady={onGridReady}
            serverSideDatasource={new MyAssigneModalServerSideDatasource()}
          />
        </div>
      </div>
    </>
  );
};
export default MyInvitations;
